module.exports = __webpack_public_path__ + "static/smoke_mephit-86677d339f98e7fe7e80c31c1fe7003c.jpg";